import {
  FETCH,
  DONE,
  FAIL,
  GET, EXAM
} from "../../constants";

import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {TFetch} from "../../types";

const initialState: TFetch = {
  exam: {
    ...reducerStatuses,
    data: null as any,
  },
};

export default createReducer(initialState, builder =>
  builder
    .addCase(GET + EXAM + FETCH, (state) => ({
      ...state,
      exam: {
        ...initialState.exam,
        loading: true
      }
    }))
    .addCase(GET + EXAM + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      exam: {
        ...initialState.exam,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + EXAM + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      exam: {
        ...initialState.exam,
        failed: true
      }
    }))
)